import { render, staticRenderFns } from "./ChooseSubscription.vue?vue&type=template&id=68352e1c&scoped=true"
import script from "./ChooseSubscription.vue?vue&type=script&lang=js"
export * from "./ChooseSubscription.vue?vue&type=script&lang=js"
import style0 from "./ChooseSubscription.vue?vue&type=style&index=0&id=68352e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68352e1c",
  null
  
)

export default component.exports